import React from 'react';
import api from '../../../services/api';
import Snackbar from '../../../services/snackbar';

export default function JurisdictionDeleteModal({ onClose, item }) {
  const deleteJurisdiction = async () => {
    await api.account.user.cle_settings.delete({ id: item.id }).then(() => {
      Snackbar.show(`Jurisdiction ${item.cle_jurisdiction.name} deleted.`);
      window.location.reload();
    }).catch(() => Snackbar.show('Cant delete jurisdiction.'));

    onClose();
  };

  return (
    <div className="new-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              <img className="react-header-logo" src="/logo_dark.svg" alt="" />
            </div>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to delete your CLE jurisdiction?</p>

            <div className="button-row">
              <div className="modal-button" onClick={deleteJurisdiction}>
                Delete Jurisdiction
              </div>

              <div className="modal-button modal-button-outline" onClick={onClose}>
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
